import dayjs from 'dayjs';

import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import DynamicList from 'components/list/DynamicList';
import { FilterAction, FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ADMIN, ENUMS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const MissingMappingStatusesDetailedList = () => {
	const columns = useMemo(
		() => [
			{
				Header: 'deliveryCompanyName',
				accessor: 'deliveryCompanyName',
				filterType: FilterType.string
			},
			{
				Header: 'deliveryCompanyID',
				accessor: 'deliveryCompanyId',
				filterType: FilterType.number
			},
			{
				Header: 'otoOrderId',
				accessor: 'otoOrderId',
				filterType: FilterType.number
			},
			{
				Header: 'shipmentNumber',
				accessor: 'shipmentNumber',
				filterType: FilterType.string
			},
			{
				Header: 'orderStatus',
				accessor: 'orderStatus',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.ALL_STATUSES,
				renderCell: ListComponents.OTO_ORDER_STATUS_HISTORY
			},
			{
				Header: 'createdBy',
				accessor: 'createdBy',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'createdDate',
				accessor: 'createdDate',
				filterType: FilterType.date,
				width: 100,
				renderCell: ListComponents.DATETIME,
				show: false
			},
			{
				Header: 'dcStatus',
				accessor: 'dcStatus',
				filterType: FilterType.string
			},
			{
				Header: 'mappingAction',
				accessor: 'mappingAction',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.STATUS_MAPPING_ACTIONS
			},
			{
				Header: 'integrationName',
				accessor: 'integrationName',
				filterType: FilterType.string
			},
			{
				Header: 'statusIntegrationName',
				accessor: 'statusIntegrationName',
				filterType: FilterType.string
			},
			{
				Header: 'dcDescription',
				accessor: 'dcDescription',
				filterType: FilterType.string
			},
			{
				Header: 'trackingUrl',
				accessor: 'trackingUrl',
				filterType: FilterType.string,
				renderCell: ListComponents.TRACKING_URL
			}
		],
		[]
	);

	const defaultSort = useMemo(() => [{ id: 'createdDate', desc: true }], []);

	const defaultFilters = useMemo(
		() => [
			{
				column: columns.find((col) => col.accessor === 'createdDate'),
				action: FilterAction.between,
				value: {
					start: dayjs().startOf('day').toISOString(),
					end: dayjs().endOf('day').toISOString()
				}
			}
		],
		[columns]
	);

	return (
		<DynamicList
			id={DYNAMICLISTS.MISSING_MAPPING_STATUSES_DETAILED}
			columns={columns}
			defaultSort={defaultSort}
			defaultFilters={defaultFilters}
			infiniteScroll
			fetchUrl={ADMIN.STATUS_MANAGEMENT.GET_MISSING_STATUS_MAPPING_DETAILED_LIST}
			actionObjectType={ACTION_OBJECT_TYPES.ADMIN}
		/>
	);
};

export default MissingMappingStatusesDetailedList;
